import * as React from 'react';

interface Props {
  readonly value?: string | string[] | number;
  readonly onUpdateValue: (value: string) => void;
  readonly className?: string;
  readonly locked?: boolean;
  readonly placeholder?: string;
}

class BelfiusIban extends React.Component<Props> {

    handleChangeIban(event: React.ChangeEvent<HTMLInputElement>) {
        const match = event.target.value.match('^[a-zA-Z][a-zA-Z][0-9]+$')
          || event.target.value.match('^[a-zA-Z][a-zA-Z]$')
          || event.target.value.match('^[a-zA-Z]$')
          || event.target.value === '';
          if (match) {
            this.props.onUpdateValue(event.target.value);
          }
      }

  render() {
    return (
        <input className={this.props.className}
        disabled={this.props.locked}
        placeholder={this.props.placeholder}
        value={this.props.value}
        autoComplete='off'
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            this.handleChangeIban(event);
        }} />
    );
  }
}

export { BelfiusIban };
